<template>
  <div class="newVue">
    <!-- Chargement -->
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
  
    <div v-else>
      <v-subheader>{{ $tc('sites', sites.length, { count: sites.length }) + ' (' + $store.state._User.entNbSite + ' max)'}}</v-subheader>
      <v-expansion-panel>
        <v-expansion-panel-content v-for="(site,i) in sites" :key="i">
          <div slot="header">{{ site.name }} <code>{{ site.url }}</code></div>
          <v-card>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-switch
                    :label="site.isValid ? 'Le site est activé' : 'Le site est désactivé'"
                    v-model="site.isValid"
                    color="primary"
                    :disabled="site.isValid"
                  ></v-switch>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-text-field v-model="site.name" :label="$t('name') | cap"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-text-field v-model="site.url" label="URL"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-text-field v-model="site.contact" :label="$t('contactEmail') | cap"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-text-field v-model="site.copii" :label="$t('copyEmail') + ' ' + $t('separatedSemiColon') | cap"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-text-field disabled v-model="site.phone" :label="$t('phone') + ' (' + $t('callback') + ')' | cap"></v-text-field>
                </v-flex>
              </v-layout>    
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <!-- <v-select :items="yesno" v-model="site.isValid" :label="$t('ecomm') + ' ' + $t('enabled') + '?' | cap" auto /></v-select> -->
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-select
                    :items="language"
                    v-model="site.lang"
                    :label="$t('language') | cap"
                    menu-props="auto"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm3>
                  <v-subheader>{{ $tc('agents', site.agentMapped.length, { count: site.agentMapped.length }) | cap}}</v-subheader>
                </v-flex>
                <template>
                  <v-container fluid class="pa-0">
                    <v-layout row wrap >
                      <v-flex md12 sm12 v-for="(agent,j) in site.agentMapped" :key="j">
                        <div class="text-xs-left ma-2">
                          <v-chip class="indigo white--text">
                            <v-avatar>
                              <img :src="agent.avatar" alt="">
                            </v-avatar>
                            {{ agent.text }}
                          </v-chip>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </template>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <div class="text-xs-right">
      <v-fab-transition v-if="canAdd">
        <v-btn
          dark
          class="secondary"
          fab
          @click.native.stop="openDialogCreate">
          <v-icon>add</v-icon>
        </v-btn>
      </v-fab-transition>
      </div>
      <!-- DIALOGUE -->
      <v-dialog v-model="showDialogCreate" persistent max-width="320">
        <v-card>
          <v-card-title class="primary white--text">
            <v-icon dark>language</v-icon>
            <span class="title pl-2">{{ $t('add') | cap }} {{ $tc('sites', 1, {count: 1}) }}</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              autofocus
              :label="$t('name') | cap" 
              v-model="newSiteDialog.name"
              counter 
              max="32" 
              v-validate="'max:32'" 
              data-vv-name="newSiteName"
              @keyup.native.enter="submitDialogCreate" 
            ></v-text-field>
            <v-text-field
              autofocus
              label="URL" 
              v-model="newSiteDialog.url"
              counter 
              max="255" 
              required
              v-validate="'required|max:255'" 
              data-vv-name="newSiteUrl"
              @keyup.native.enter="submitDialogCreate" 
            ></v-text-field>
            <v-switch
              :label="$t('enabled') + '?' | cap"
              v-model="newSiteDialog.activated"
              color="primary"
            ></v-switch>
            <v-switch
              :label="$t('associateAllAgents')"
              v-model="newSiteDialog.allAgents"
              color="primary"
            ></v-switch>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="showDialogCreate = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" flat @click.native="submitDialogCreate">{{ $t('submit') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div class="text-xs-right">
        <v-btn color="primary"         
  	    fixed
          bottom
          right
          @click.native="submit">
            {{ $t('save') | cap }}<v-icon dark right>send</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { LEVEL, DOMAINE } from '../../constants'
import { mapActions } from 'vuex'
export default {
  data () {
    return {
      /**
       * indique si une requête ajax en cours
       * @type {Boolean}
       */
      loading: false,
      /**
       * affiche/cache la fenetre de dialog de création
       * @type {Boolean}
       */
      showDialogCreate: false,
      /**
       * nouvelle bibliothèque à créer
       * @type {Object}
       */
      newSiteDialog: { activated: '1', allAgents: '0' },
      name: 'Gestion des sites',
      /**
       * Liste des sites affichés
       * @type {Array}
       */
      sites: [],
      resAjx: null,
      resAjxMap: null,
      language: [
        { text: 'French', value: 'FR' },
        { text: 'English', value: 'EN' },
        { text: 'Espanol', value: 'ES' },
        { text: 'Italian', value: 'IT' },
        { text: 'German', value: 'DE' },
        { text: 'Portugese', value: 'PT' }
      ],
      yesno: [{ text: 'Oui', value: '1' }, { text: 'Non', value: '0' }]
    }
  },
  created () {
    /* eslint-disable */
    if (typeof (defautMotif) !== 'undefined') {
      defautMotif = 'management_sites'
    }
    else {
      setTimeout (function () {
        if (typeof (defautMotif) !== 'undefined') {
          defautMotif = 'management_sites'
        }
      }, 800);
    }
    /* eslint-enable */
  },
  mounted () {
    this.loading = true
    this.axios.get('get/sites.php').then(response => {
      this.resAjx = response.data
      this.axios
        .get('get/mapping.php')
        .then(response => {
          console.log('site.js --> mapping.php', response)
          this.resAjxMap = response.data
          this.init()
        })
        .catch()
        .then(_ => {
          this.loading = false
        })
    })
  },

  computed: {
    canAdd () {
      let rights = this.$store.getters['_User/level'].rights
      return (
        rights !== LEVEL.CHAT &&
        this.sites.length < this.$store.state._User.entNbSite
      )
    }
  },

  methods: {
    ...mapActions('_Sites', ['GET']),

    /**
     * Création et ajout d'un nouveau composant dynamique
     */
    create () {},
    init () {
      for (var id in this.resAjx) {
        var _agentList = []
        for (var idMap in this.resAjxMap) {
          var usrListFromSql = this.resAjxMap[idMap][0].LIC_USR_LIST
          for (var j in usrListFromSql) {
            if (id === idMap) {
              _agentList.push({
                text: usrListFromSql[j][1] + ' ' + usrListFromSql[j][2],
                value: usrListFromSql[j][0],
                avatar: `${DOMAINE}/public/media/user/small/${
                  usrListFromSql[j][0]
                }_avatar.jpg`
              })
            }
          }
        }
        let nameSite = this.resAjx[id][0].LIC_COMMENT
        if (
          !this.resAjx[id][0].LIC_COMMENT ||
          this.resAjx[id][0].LIC_COMMENT === ''
        ) {
          nameSite = this.resAjx[id][0].LIC_URL
        }
        this.sites.push({
          id: this.resAjx[id][0].LIC_ID,
          url: this.resAjx[id][0].LIC_URL,
          isValidBool: !!+this.resAjx[id][0].LIC_IS_VALID,
          isValid: _.toInteger(this.resAjx[id][0].LIC_IS_VALID) === 1,
          name: nameSite,
          eezyLead: this.resAjx[id][0].LIC_EEZY_LEAD,
          phone: this.resAjx[id][0].LIC_CALLBACK_PHONE,
          contact: this.resAjx[id][0].LIC_CONTACTS,
          copii: this.resAjx[id][0].LIC_CONTACT_COPY,
          lang: this.resAjx[id][0].LIC_DEFAULT_LANG,
          callback: this.resAjx[id][0].LIC_CALLBACK_ACTIVATED,
          recall: this.resAjx[id][0].LIC_RECALL_ACTIVATED,
          cobrowsing: this.resAjx[id][0].LIC_COBROWSING_ACTIVATED,
          superIstyping: this.resAjx[id][0].LIC_SUPERISTYPING_ACTIVATED,
          funnel: this.resAjx[id][0].LIC_IS_FUNNEL,
          skey: this.resAjx[id][0].LIC_KEY,
          deskId: this.resAjx[id][0].LIC_DSK_ID,
          agentMapped: _agentList
        })
      }
    },
    /**
     *  Valide le formulaire et update la BDD et le fichier XML pour le front
     */
    submit () {
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('sites', JSON.stringify(this.sites))
      dataToPost.append('ENT_ID', this.$store.state._User.entId)

      // onboarding
      let steps = JSON.parse(this.$store.state._User.remainingSteps)
      // si cette étape est encore dans le tableau
      if (steps && typeof steps !== 'undefined' && steps.indexOf('INS_MANAGEMENT_SITES')) {
        // on l'efface du tableau
        steps.splice(steps.indexOf('INS_MANAGEMENT_SITES'), 1)
        // mise à jour du store _User
        this.$store.commit('_User/MAJ_PROGRESSION', {
          remainingSteps: JSON.stringify(steps)
        })
      }
      // steps.splice(steps.indexOf('INS_SETTINGS_CHAT'), 1)
      // this.$store.state._User.remainingSteps = JSON.stringify(steps)
      // this.$store.state._User.installProgress += 10

      this.axios
        .post('post/sites.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          this.updateSites('U')
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifFailure'),
            context: 'error'
          })
        })
        .then(_ => {})
    },
    /**
     * ouvre la fenêtre de dialogue et initialise une nouvelle bibliothèque à créer
     */
    openDialogCreate () {
      this.showDialogCreate = true
    },
    /**
     * valide la nouvelle bibliothèque à créer
     */
    submitDialogCreate () {
      if (_.isEmpty(this.newSiteDialog.url)) {
        // Notification
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Impossible de le créer, url vide',
          context: 'warning'
        })
        return
      }
      this.showDialogCreate = false
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('newsite', JSON.stringify(this.newSiteDialog))
      this.axios
        .post('post/newsite.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          this.updateSites('C')
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('creationFailure'),
            context: 'error'
          })
        })
        .then(_ => {
          this.axios
            .get('get/sites.php')
            .then(response => {
              this.resAjx = response.data
              this.sites = []
              this.init()
            })
            .catch()
            .then(_ => {
              // this.loading = false
            })
        })
    },

    updateSites (mode) {
      let message = mode === 'C'
        ? {success: 'creationSuccess', error: 'creationFailure'}
        : {success: 'modifSuccess', error: 'modifFailure'}
      this.GET()
        .then(() => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t(message.success),
            context: 'success'
          })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t(message.error),
            context: 'error'
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/management/Sites.vue